// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.sen-styles-text-dYkJNqaH{line-height:24px}`, "",{"version":3,"sources":["webpack://./src/components/Sensors/ActionButtons/StopDataCapture/styles.scss"],"names":[],"mappings":"AAAA,0BACE,gBAAA","sourcesContent":[".text {\n  line-height: 24px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"text": `sen-styles-text-dYkJNqaH`
};
export default ___CSS_LOADER_EXPORT___;
